@let isFullVerification = isFullVerification$ | async; @let basicVerification =
basicVerification$ | async;

<svg-icon-sprite
  [src]="'./assets/img/icons/sprite.svg#close'"
  mat-dialog-close
  class="close"
>
</svg-icon-sprite>

<h3 class="title" translate="deposit-bonus.terms.title"></h3>
<p class="text" translate="deposit-bonus.terms.text"></p>

@if (!data.wasFirstBonusReceived) {
<!--  Пользователь не получал бонус -->
<ul class="list list--bullet">
  <li [translate]="'deposit-bonus.terms.first.point1'"></li>
  <li [translate]="'deposit-bonus.terms.first.point2'"></li>
  <li [translate]="'deposit-bonus.terms.first.point3'"></li>
</ul>
} @else {
<ul class="list list--bg">
  <li [translate]="'deposit-bonus.terms.second.point1'"></li>
  <li [translate]="'deposit-bonus.terms.second.point2'"></li>
  <li [translate]="'deposit-bonus.terms.second.point3'"></li>
  <li [translate]="'deposit-bonus.terms.second.point4'"></li>
  <li [translate]="'deposit-bonus.terms.second.point5'"></li>
  <li [translate]="'deposit-bonus.terms.second.point6'"></li>
</ul>

<p class="text" translate="deposit-bonus.terms.first.point3"></p>
}

<ng-container [ngTemplateOutlet]="limitsTmpl"></ng-container>

@if (isFullVerification) {
<p
  [innerHTML]="'deposit-bonus.terms.link' | translate : { link: data.termsLink }"
  class="terms text"
></p>
}

@let btnInfo = getBtnInfo(isFullVerification, basicVerification);

<btn
  [wide]="true"
  [buttonText]="btnInfo.title | translate"
  [routerLink]="btnInfo.routerLink"
  (click)="onButtonClicked(isFullVerification)"
  class="action-button"
  mat-dialog-close
></btn>

<ng-template #limitsTmpl>
  <h4 class="title title--sub" translate="deposit-bonus.terms.subtitle"></h4>

  <ul class="list list--bullet">
    <li [translate]="'deposit-bonus.terms.limit.point1'"></li>
    <li [translate]="'deposit-bonus.terms.limit.point2'"></li>
    <li [translate]="'deposit-bonus.terms.limit.point3'"></li>
    <li [translate]="'deposit-bonus.terms.limit.point4'"></li>
    <li [translate]="'deposit-bonus.terms.limit.point5'"></li>
  </ul>
</ng-template>
